// Constant Variables
const injectionMethod = 'prepend'
const isSubscription = document.querySelector('[data-subscription-button-container]')
const params = {
  injectionParent: isSubscription,
  injectionMethod
}

// Functions
const makeConfig = (el, params) => {
  const productId = parseInt(el.dataset.productId, 10)
  const { injectionParent, injectionMethod } = params
  const config = {
    productId,
    injectionParent,
    injectionMethod,
    injectFn: (node, target) => {
      console.log(node, target)
    }
  }
  return config
}

const addRechargeWidget = () => { 

}


// Middleware function
const buildRechargeWidget = (el, params) => {
  const config = makeConfig(el, params)
  window.ReChargeWidget.createWidget(config)
}

// Endpoint Function
window.addEventListener('ReChargeWidget-loaded', () =>  
  isSubscription && buildRechargeWidget(isSubscription, params))